import { useEffect, useRef, useState } from 'react';
import { fetchNotificationsService } from '../../store/investor/service';
import { GetNotificationsResponse } from './NotificationCenter.types';
import { UNREAD_POLL_INTERVAL_MS } from './NotificationCenter.constants';
import { getPlatformUserId } from '../../utils/utils';

export function useUnreadCount(enabled: boolean): { unreadCount: number; refresh: () => void } {
    const organisationUserId = getPlatformUserId();
    const [unreadCount, setUnreadCount] = useState(0);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const fetchCount = async () => {
        if (!enabled || !organisationUserId) return;
        try {
            const res = await fetchNotificationsService({ organisationUserId, pageNum: 0, pageSize: 1 });
            const data: GetNotificationsResponse = res.data?.responseData ?? res.data;
            setUnreadCount(data.unreadCount ?? 0);
        } catch {
            // Silent fail — badge stays at last known value
        }
    };

    useEffect(() => {
        if (!enabled || !organisationUserId) return;
        fetchCount();
        intervalRef.current = setInterval(fetchCount, UNREAD_POLL_INTERVAL_MS);
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [enabled]);

    return { unreadCount, refresh: fetchCount };
}
